import logEvent from '../../logEvent';

function logEventAssistedAddBeneficiary(code, data) {
  logEvent(`UFAB-${code}`, data);
}

export function logEventAssistedAddBeneficiarySelectPlan() {
  logEventAssistedAddBeneficiary('01');
}

export function logEventAssistedAddBeneficiaryDetails(data) {
  logEventAssistedAddBeneficiary('02', data);
}

export function logEventAssistedAddBeneficiarySIN() {
  logEventAssistedAddBeneficiary('03');
}

export function logEventAssistedAddBeneficiaryDetailsReview() {
  logEventAssistedAddBeneficiary('04');
}

export function logEventAssistedAddBeneficiarySuccess() {
  logEventAssistedAddBeneficiary('05');
}

export function logEventAssistedAddBeneficiaryCantAddWithoutPlan() {
  logEventAssistedAddBeneficiary('06');
}

export function logEventAssistedAddBeneficiaryCannotSubmitted() {
  logEventAssistedAddBeneficiary('07');
}
